import PersonalLinks from "../constants/personalLinks";
import ThemeToggle from "./ui/ThemeToggle";
import { AiFillGithub, AiOutlineInstagram, AiFillLinkedin } from "react-icons/ai";
import { useLanguage } from "../context/LanguageContext";

const labels = {
  tr: {
    home: "Ana Sayfa",
    about: "Hakkımda",
    projects: "Projeler",
    social: "Sosyal Medya",
    contact: "İletişim",
  },
  en: {
    home: "Home",
    about: "About",
    projects: "Projects",
    social: "Social",
    contact: "Contact",
  },
};

function Header() {
  const { language } = useLanguage();
  const t = labels[language] || labels.tr;

  return (
    <nav className="glass-nav site-nav">
      <div className="container nav-inner">
        <a className="logo" href="/#home">
          RukiTech
        </a>

        <ul className="nav-links">
          <li><a href="/#home">{t.home}</a></li>
          <li><a href="/#about">{t.about}</a></li>
          <li><a href="/#tech">{t.projects}</a></li>
          <li><a href="/#reach">{t.social}</a></li>
          <li><a href="/#contact">{t.contact}</a></li>
        </ul>

        <div className="nav-actions">
          <a className="icon-link" href={PersonalLinks.github} target="_blank" rel="noreferrer noopener" aria-label="GitHub">
            <AiFillGithub />
          </a>
          <a className="icon-link" href={PersonalLinks.linkedin} target="_blank" rel="noreferrer noopener" aria-label="LinkedIn">
            <AiFillLinkedin />
          </a>
          <a className="icon-link" href={PersonalLinks.instagram} target="_blank" rel="noreferrer noopener" aria-label="Instagram">
            <AiOutlineInstagram />
          </a>
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
}
export default Header;
